import React from "react";
import styled, { css } from "styled-components";

import { config } from "_config";

import breakpoints from "_constants/breakpoints";

import { ReactComponent as ChatSmileSVG } from "assets/img/ChatSmile.svg";
import { ReactComponent as PhoneSVG } from "assets/img/Phone.svg";
import { ReactComponent as PaymentIconsSVG } from "assets/img/PaymetIcons.svg";
import { ZendeskAPI } from "react-zendesk";

import union from "assets/img/Union.png";

const Container = styled.div`
  background-color: #a5aaaf;
`;
const ContainerWrapper = styled.div`
  max-width: 1188px;
  margin: 0 auto;
  padding: 0 4px 20px;
`;
const Links = styled.div`
  border-bottom: 1px solid rgba(236, 237, 241, 0.3);
  padding: 32px 0;
  align-items: center;
  @media (max-width: ${breakpoints.mobileL}) {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
`;
const LinksWrapper = styled.div`
  width: ${({ theme: { mobile } }) => (mobile ? "50%" : "24%")};
  display: inline-block;
  vertical-align: top;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 24px;

  @media (max-width: ${breakpoints.mobileL}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: auto;
  }

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 600px) {
        padding: 0 10px;
      }
    `}
`;
const GroupTitle = styled.h4`
  font-family: "Montserrat";
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 17px;
`;
const Link = styled.a`
  display: block;
  font-family: "Montserrat";
  font-size: 12px;
  line-height: 15px;
  color: #ecedf1;
  text-decoration: none;
  margin-bottom: 12px;
  &:hover {
    color: #ecedf1;
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.mobileL}) {
    font-size: 14px;
  }
`;
const LiveChatLink = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: #f37217;
  font-weight: 700;
  margin: 0;
  &:hover {
    color: #f37217;
    text-decoration: none;
  }
`;
const LiveChatContainer = styled.div`
  display: flex;
  cursor: pointer;
  background-image: url(${union});
  height: 63px;
  width: 140px;
  padding: 12px 13px 29px 14px;
  margin-bottom: 54px;
`;
const PhoneContainer = styled.div`
  display: flex;
`;
const PhoneNumber = styled.a`
  font-family: "Montserrat";
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  color: #fafaff;
  text-decoration: none;
  margin: 0;
  &:hover {
    color: #fafaff;
    text-decoration: none;
  }
`;
const PhoneAvailability = styled.p`
  font-style: normal;
  font-size: 10px;
  line-height: 12px;
  color: #fafaff;
  font-weight: bold;
  margin: 0;
`;
const Payments = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;
const Copyright = styled.p`
  font-size: 11px;
  line-height: 13px;
  font-weight: 400;
  text-align: center;
  color: #ecedf1;
  margin: 24px auto 0;
  padding: 0 25px;
  max-width: 980px;
`;

export default function Footer() {
  const handleChat = () => {
    ZendeskAPI("webWidget", "show");
    ZendeskAPI("webWidget", "open");

    ZendeskAPI("webWidget:on", "close", function () {
      ZendeskAPI("webWidget", "hide");
    });
  };
  return (
    <Container>
      <ContainerWrapper>
        <Links>
          <LinksWrapper>
            <GroupTitle>Quick links</GroupTitle>
            <Link href={`${config.trademarkUiUrl}/trademark-registration`}>Trademark Registration</Link>
            <Link href={`${config.trademarkUiUrl}/comprehensive-trademark-search`}>Comprehensive Search</Link>
            <Link href={`${config.trademarkUiUrl}/trademark-monitoring`}>Trademark Monitoring</Link>
            <Link href={`${config.trademarkUiUrl}/search`}>Free Trademark Search</Link>
            <Link href={`${config.trademarkUiUrl}/trademark-registration`}>Copyright Registration</Link>
            <Link href={`${config.trademarkUiUrl}/office-action`}>Office Action Responce</Link>
          </LinksWrapper>
          <LinksWrapper>
            <GroupTitle>Company</GroupTitle>
            <Link href={`${config.trademarkUiUrl}/about`}>About Us</Link>
            <Link href={`${config.trademarkUiUrl}/contact`}>Contact Us</Link>
            <Link href={`${config.trademarkUiUrl}/guarantee`}>Our Guarantee</Link>
            <Link href={`${config.trademarkUiUrl}/`}>Terms of Service</Link>
            <Link href={`${config.trademarkUiUrl}/privacy`}>Privacy Policy</Link>
          </LinksWrapper>
          <LinksWrapper>
            <GroupTitle>Connect with us</GroupTitle>
            <Link href={`${config.trademarkUiUrl}/about`}>About Us</Link>
          </LinksWrapper>
          <LinksWrapper>
            <GroupTitle>Assistance</GroupTitle>
            <LiveChatContainer onClick={handleChat}>
              <ChatSmileSVG style={{ marginRight: "10px" }} />
              <LiveChatLink>Live&nbsp;Chat</LiveChatLink>
            </LiveChatContainer>
            <PhoneContainer>
              <PhoneSVG width="24px" height="24px" color="#ECEDF1" />
              <div>
                <PhoneNumber href="tel:+18002706305">(800) 270 - 6305</PhoneNumber>
                <PhoneAvailability>Mon – Fri: 9am - 5pm</PhoneAvailability>
              </div>
            </PhoneContainer>
          </LinksWrapper>
        </Links>
        <Payments>
          <PaymentIconsSVG />
        </Payments>
        <Copyright>
          © Copyright 2021 Trademark Genius, LLC. Trademark Engine provides information and software only. Trademark
          Engine is not a &quot;lawyer referral service&quot; and does not provide legal advice or participate in any
          legal representation. Use of Trademark Engine is subject to our Terms of Service and Privacy Policy.
        </Copyright>
      </ContainerWrapper>
    </Container>
  );
}
